import { Component } from '@angular/core';
import { ClipboardModule } from 'ngx-clipboard';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrl: './alert-message.component.scss',
  standalone: true,
  imports: [CommonModule, FormsModule, ClipboardModule]
})
export class AlertMessageComponent {
  size: 'S' | 'M' = 'M';
  type: 'default' | 'warning' | 'success' | 'error' = 'default';
  title = '';
  text = 'Lorem ipsum, dolor sit amet consectetur adipisicing elit.';
  hasTitle = false;

  alertClasses = 'alertMessage size-M default';
  htmlCode = '';

  constructor() {
    this.updateAlert();
  }

  updateAlert() {
    const classes = ['alertMessage'];
    classes.push(`size-${this.size}`);
    classes.push(this.type);

    this.alertClasses = classes.join(' ');

    this.generateHTMLCode();
  }

  generateHTMLCode() {
    const indent = (level: number) => '  '.repeat(level);

    let htmlCode = `<div class="${this.alertClasses}">
${indent(1)}<i class="fa-regular fa-circle-info"></i>
${indent(1)}<div>`;

    if (this.hasTitle && this.title) {
      htmlCode += `
${indent(2)}<p class="alertMessage__title">${this.title}</p>`;
    }

    htmlCode += `
${indent(2)}<span>${this.text}</span>
${indent(1)}</div>
</div>`;

    this.htmlCode = htmlCode;
  }

  onSizeChange() {
    this.updateAlert();
  }

  onTypeChange() {
    this.updateAlert();
  }

  onTitleToggle() {
    this.updateAlert();
  }

  onTitleChange() {
    this.updateAlert();
  }

  onTextChange() {
    this.updateAlert();
  }
}
